import {
  REMOVE_AREA_ENTRY_STRATEGY,
  REMOVE_AREA_ENTRY_STRATEGY_FAILED,
  REMOVE_AREA_ENTRY_STRATEGY_SUCCESSFUL,
} from './actionTypes';

const initialState = {
  errorRemoveAreaEntryStrategy: '',
  loadingRemoveAreaEntryStrategy: false,
  successRemoveAreaEntryStrategy: '',
};

const removeAreaEntryStrategy = (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_AREA_ENTRY_STRATEGY:
      state = {
        ...state,
        loadingRemoveAreaEntryStrategy: true,
      };
      break;
    case REMOVE_AREA_ENTRY_STRATEGY_SUCCESSFUL:
      state = {
        ...state,
        loadingRemoveAreaEntryStrategy: false,
        successRemoveAreaEntryStrategy: action.payload.message,
      };
      break;
    case REMOVE_AREA_ENTRY_STRATEGY_FAILED:
      state = {
        ...state,
        errorRemoveAreaEntryStrategy: action.payload.message,
        loadingRemoveAreaEntryStrategy: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default removeAreaEntryStrategy;
